import AccountName from "../../../../_utils/AccountCreationComponents/AccountName";
import ContactDetails from "../../../../_utils/AccountCreationComponents/ContactDetails";
import CommonLayout from "../../../../_utils/CommonLayout";
import "./index.css";

const BeneficiaryAccountStepContact = ({
  accountNameValidation,
  selectedValue,
  payload,
  handleDivBtn,
  handleChange,
  handleRadioBtn,
  contactNumberValidation,
  emailValidation,
}) => {
  return (
    <>
      <div className="px-padding-md lg:px-padding-base py-padding-md Qsmd:py-padding-base max-w-tab-width-normal w-full mx-auto">
        <CommonLayout>
          <AccountName
            handleChange={handleChange}
            accountNameValidation={accountNameValidation}
            accountName={payload.account_name}
            selectedValue={selectedValue}
            handleDivBtn={handleDivBtn}
            handleRadioBtn={handleRadioBtn}
            selectedRadioValue={selectedValue}
            legalName={payload?.legalName}
            userName={payload.userName}
          />

          <div className="Qlg:pb-padding-base pb-padding-md">
            <ContactDetails
              handleChange={handleChange}
              contactNumberValidation={contactNumberValidation}
              emailValidation={emailValidation}
              contactNumber={payload.contact_no}
              emailId={payload.email_id}
              selectedValue={selectedValue}
            />
          </div>
        </CommonLayout>
      </div>
    </>
  );
};

export default BeneficiaryAccountStepContact;
